module.exports = __webpack_public_path__ + "static/img/kjdy8.41f09cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy8.png
// module id = 343
// module chunks = 0